export const API_URL =
  process.env.REACT_APP_API_URL ??
  (process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '');

export function getBookCoverImage(book) {
  if (book.cover_image_url) {
    return book.cover_image_url;
  }

  const coverMap = {
    'The Great Gatsby': '/imgs/The_Covered_Wagon.png',
    'To Kill a Mockingbird': '/imgs/The_Crystal_Crypt.png',
    '1984': '/imgs/The_Damned_Thing.png'
  };
  return coverMap[book.name] || '/imgs/The_Covered_Wagon.png';
}

export function groupByFirstLetter(items, getLabel) {
  const groups = {};

  items.forEach((item) => {
    const label = (getLabel(item) || '').trim();
    const first = label ? label[0].toUpperCase() : '#';
    const letter = /[A-Z]/.test(first) ? first : '#';
    if (!groups[letter]) {
      groups[letter] = [];
    }
    groups[letter].push(item);
  });

  const letters = Object.keys(groups).sort((a, b) => {
    if (a === '#') return 1;
    if (b === '#') return -1;
    return a.localeCompare(b);
  });

  return letters.map((letter) => ({
    letter,
    items: groups[letter].sort((a, b) =>
      (getLabel(a) || '').localeCompare(getLabel(b) || '', undefined, { sensitivity: 'base' })
    )
  }));
}
